export const environment = {
    production: false,
    cognitoUserPoolId: 'eu-central-1_hrVSdyHMW',
    cognitoAppClientId: '775btk9240rocpell2aj65vbos',
    cognitoSignOutUrl: 'https://connedgiacc-dev.adn.naturgy.com/login',
    cognitoDomain: 'https://connedgiacc-dev.auth.eu-central-1.amazoncognito.com',
    API_URL: '/api/analytics/',
}